import BaseComponent from "../../../base/common/BaseComponent";
import { procedureJbStatus } from "../../publicDictionaryValues";

class CreateProcedureTableData extends BaseComponent {
  createProcedureData = (files: any, ref: any, status: any) => {
    const dataList: any[] = [];
    files !== null &&
      files.forEach((item: any) => {
        const lineId = this._generateGUID();
        dataList.push({
          data: [
            { name: "lineId", value: lineId },
            { name: "procedureFileID", value: item.procedureFileID },
            { name: "fileId", value: item.fileId },
            { name: "fileKey", value: item.fileKey },
            {
              name: "fileName",
              value: item.fileName,
            },
            { name: "uploadedDate", value: this._formateDate(item.uploadedOn) },
            { name: "uploadByName", value: item.uploadedByName },
            { name: "uploadBy", value: item.uploadedBy },
            { name: "note", value: item.note },
            {
              name: "approveDate",
              value: this._formateDate(item.approvedDate),
            },
            { name: "fileOperate", value: 1 },
            // @ts-ignore
            { name: "jbProcedure", value: procedureJbStatus[item.jbProcedure] },
          ],
          checked: false,
        });
      });
    ref?.current && ref.current.updateDataList(dataList);
    return dataList;
  };

  createUpdateProcedureData = (files: any, ref: any) => {
    const dataList: any[] = [];
    files !== null &&
      files.forEach((item: any) => {
        const lineId = this._generateGUID();
        dataList.push({
          data: [
            { name: "lineId", value: lineId },
            { name: "procedureFileID", value: item.procedureFileID },
            { name: "initFileId", value: item.fileId },
            { name: "fileId", value: item.fileId },
            { name: "initFileKey", value: item.fileKey },
            { name: "fileKey", value: item.fileKey },
            { name: "initFileName", value: item.fileName },
            {
              name: "fileName",
              value: item.fileName,
            },
            { name: "uploadedDate", value: this._formateDate(item.uploadedOn) },
            { name: "uploadByName", value: item.uploadedByName },
            { name: "uploadBy", value: item.uploadedBy },
            { name: "proposedChange", value: "" },
            {
              name: "approveDate",
              value: this._formateDate(item.approvedDate),
            },
            { name: "approveTime", value: item.approvedDate },
            { name: "fileOperate", value: 1 },
            // @ts-ignore
            { name: "jbProcedure", value: procedureJbStatus[item.jbProcedure] },
          ],
          checked: false,
        });
      });
    ref?.current && ref.current.updateDataList(dataList);
    return dataList;
  };

  createSupportingData = (files: any, ref: any) => {
    const dataList: any[] = [];
    files !== null &&
      files.forEach((item: any) => {
        const lineId = this._generateGUID();
        dataList.push({
          data: [
            { name: "lineId", value: lineId },
            { name: "fileId", value: item.fileId },
            { name: "fileKey", value: item.fileKey },
            {
              name: "fileName",
              value: item.fileName,
            },
            { name: "uploadedDate", value: this._formateDate(item.uploadedOn) },
            { name: "uploadByName", value: item.uploadedByName },
            { name: "uploadBy", value: item.uploadedBy },
            { name: "note", value: item.note },
            {
              name: "approveDate",
              value: this._formateDate(item.approvedDate),
            },
            { name: "fileOperate", value: 1 },
            { name: "jbProcedure", value: "" },
          ],
          checked: false,
        });
      });
    ref?.current && ref.current.updateDataList(dataList);
    return dataList;
  };

  createUpdateSupportingData = (files: any, ref: any) => {
    const dataList: any[] = [];
    files !== null &&
      files.forEach((item: any) => {
        const lineId = this._generateGUID();
        dataList.push({
          data: [
            { name: "lineId", value: lineId },
            { name: "initFileId", value: item.fileId },
            { name: "fileId", value: item.fileId },
            { name: "initFileKey", value: item.fileKey },
            { name: "fileKey", value: item.fileKey },
            { name: "initFileName", value: item.fileName },
            {
              name: "fileName",
              value: item.fileName,
              tagValue: "",
            },
            { name: "uploadedDate", value: this._formateDate(item.uploadedOn) },
            { name: "uploadByName", value: item.uploadedByName },
            { name: "uploadBy", value: item.uploadedBy },
            { name: "proposedChange", value: "" },
            { name: "note", value: item.note },
            {
              name: "approveDate",
              value: this._formateDate(item.approvedDate),
            },
            { name: "approveTime", value: item.approvedDate },
            { name: "fileOperate", value: 1 },
            { name: "jbProcedure", value: "" },
          ],
          checked: false,
        });
      });
    ref?.current && ref.current.updateDataList(dataList);
    return dataList;
  };
}

// @ts-ignore
const createProcedureTableData = new CreateProcedureTableData();
export default createProcedureTableData;
